export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4799.ad52f101.jpg";